import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';//Link, 
import { connect } from 'react-redux';
//import { Field, reduxForm, formValueSelector } from 'redux-form';
//import { Input, PasswordInput } from '../components/Forms/Input';
import { config } from '../config';
import { alertSuccess, alertDanger } from '../actions/alertActions';
//import { timeout } from 'q';

const required = value => {
    if (value) return true; else return false;
};
const length = value => value && value.length >= 8;
const upperCase = value => value && value.toLowerCase() !== value;
const lowerCase = value => value && value.toUpperCase() !== value;

class Password extends Component {
    constructor(props) {
        super(props);
        this.state = {
            password: '',
            touched: false,
            showPassword: false,
            confirmPassword: ''
        }
        this.onChange = this.onChange.bind(this);
        this.onConfirmChange = this.onConfirmChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    toggle() { this.setState({ showPassword: !this.state.showPassword }); }

    onChange(e) {
        this.setState({ password: e.target.value });
        this.props.onChange(e);
    }

    onConfirmChange(e) {
        this.setState({ confirmPassword: e.target.value });
        this.props.onChange(e);
    }

    onBlur() { this.setState({ touched: true }); }

    render() {
        const type = this.state.showPassword ? 'text' : 'password';
        const eye = this.state.showPassword ? 'glyphicon-eye-close' : 'glyphicon-eye-open';

        const password = this.state.password;
        const touched = this.state.touched;
        const hasText = required(password);
        const minLength = length(password);
        const uppercase = upperCase(password);
        const lowercase = lowerCase(password);
        const ok = touched ? hasText && minLength && uppercase && lowercase : true;

        return (
            <div className={`form-group ${ok ? '' : 'has-error'} rel`}>
                <label>Password
                    <button className="btn-link abs-top-right no-underline" onClick={this.toggle} title="Click here to show/hide your password">
                        <span className={`glyphicon ${eye} mr-sm`}></span>
                        {this.state.showPassword ? 'Hide password' : 'Show password'}
                    </button>
                </label>
                <input type={type} className="form-control" value={this.state.password} onChange={this.onChange} onBlur={this.onBlur} />
                <label>Confirm Password</label>
                <input type={type} className="form-control" value={this.state.confirmPassword} onChange={this.onConfirmChange} onBlur={this.onBlur} />
                <div className="panel panel-info mt-md">
                    <div className="panel-body">
                        <strong>Your password should:</strong>
                        <ul>
                            <li className={minLength ? 'text-success' : ''}>Be at least 8 characters <span className={minLength ? 'glyphicon glyphicon-ok-sign' : ''}></span></li>
                            <li className={uppercase ? 'text-success' : ''}>Contain at least 1 uppercase letter <span className={uppercase ? 'glyphicon glyphicon-ok-sign' : ''}></span></li>
                            <li className={lowercase ? 'text-success' : ''}>Contain at least 1 lowercase letter <span className={lowercase ? 'glyphicon glyphicon-ok-sign' : ''}></span></li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: props.match.params.user,
            token: '',
            error: false,
            success: false,
            password: ''
        };
        this.submit = this.submit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handle = this.handle.bind(this);
    }

    handle(response) {
        //console.log(response);
        if (response.status === 400 || response.status === 403) {
            this.props.alertDanger('We could not verify your account. Try requesting a new reset password link.', 7500);
            this.setState({ error: true });
        }
        else if (response.status === 404) {
            this.props.alertDanger('We could not find your account. Try requesting a new reset password link.', 7500);
            this.setState({ error: true })
        }        
    }

    componentDidMount() {
        const params = new URLSearchParams(this.props.location.search);
        const token = params.get('token');
        this.setState({ token: token });
        fetch(config.apiUrl + `/ResetPassword/VerifyToken/${this.state.user}?token=${token}`)
            .then(res =>this.handle(res));
    }

    onChange(e) {
        this.setState({ password: e.target.value });
    }

    submit(e) {
        e.preventDefault();
        let url = config.apiUrl + `/ResetPassword/Index/${this.state.user}?token=${this.state.token}`;
        fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.state.password)
        }).then(res => {
            if (res.ok) {
                this.props.alertSuccess('Your password has been changed. Log in to access your account.');
                this.setState({ success: true })
            }
            this.handle(res)
        });
    }

    render() {
        if (this.state.error) {
            //this.props.alertDanger('We could not verify your account. Try requesting a new reset password link.');

            //return (<Redirect to="/ForgotPassword" />)
        }
        else if (this.state.success) {
            return (<Redirect to="/Login" />)
        }

        return (
            <div className="panel panel-default h-center modal-dialog">
                <div className="panel-heading">
                    <h1>Reset your password</h1>
                </div>
                <div className="panel-body">
                    <form onSubmit={this.submit}>

                        <Password onChange={this.onChange} />
                        <button className="btn btn-primary" type="submit">Reset your password</button>
                    </form>
                </div>
            </div>
        )
    }
}

export default connect(null, { alertSuccess, alertDanger })(ResetPassword);